export default "__VITE_ASSET__D5Mcn$JP__"